import openstackIcon from '@images/spe-cloud/openstack.svg';
import kubernetesIcon from '@images/spe-cloud/kubernetes.svg';
import cloudNativeIcon from '@images/spe-cloud/cloud-native.svg';
import publicCloudsIcon from '@images/spe-cloud/cloud-public.svg';

export const experience = [
  {
    title: 'OpenStack',
    icon: openstackIcon,
    sectionId: 'spe-openstack',
  },
  {
    title: 'Kubernetes / OpenShift',
    icon: kubernetesIcon,
    sectionId: 'spe-kubernetes-openshift',
  },
  {
    title: 'Cloud-native',
    icon: cloudNativeIcon,
    sectionId: 'spe-cloud-native',
  },
  {
    title: 'Public cloud',
    icon: publicCloudsIcon,
    sectionId: 'spe-public-cloud',
  },
];
